import { cloneDeep } from 'lodash-es';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { IField } from '../../../data-models/field2.data-model';
import { ColumnMeta, createColumnMeta } from '../../../types';
import {
  columnFormTransformer,
  getColumnFields,
  transformColumnBeforeSubmit,
} from '../../Config/Columns/ColumnFields';
import { CustomFieldForm2 } from '../forms2/CustomFieldForm2';
import { CustomFieldFormInitialValuesState } from '../forms2/CustomFieldFormStateJ';
import { Field3ConfigModal } from './Field3ConfigModal';
import { KpiFieldForm } from './KpiFieldForm';

interface FieldModalProps<T> {
  item?: T;
  onClose: () => void;
}

const COLUMN_DEFAULTS: Partial<ColumnMeta> = createColumnMeta({
  id: 0,
  visible: true,
  type: 'string',
  formatting: 'string',
});

export function KpiFieldModal({ item, onClose }: FieldModalProps<IField<unknown>>) {
  return <KpiFieldForm item={item} onClose={onClose} />;
}

export function ColumnFieldModal({ item, onClose }: FieldModalProps<ColumnMeta>) {
  return (
    <Field3ConfigModal<ColumnMeta>
      title={item ? 'Edit System Field' : 'Create System Field'}
      formFields={getColumnFields()}
      queryURL='/column'
      item={item}
      defaultValues={COLUMN_DEFAULTS}
      dynamicFormTransformer={columnFormTransformer}
      transformBeforeSubmit={transformColumnBeforeSubmit}
      onClose={onClose}
    />
  );
}

export function CustomFieldModal({ item, onClose }: FieldModalProps<IField<unknown>>) {
  const setInitialValues = useSetAtom(CustomFieldFormInitialValuesState);
  // The form captures its defaults from the atom at mount, so don't render it
  // until the edited item has been written there.
  const [ready, setReady] = useState(item == null);
  useEffect(() => {
    if (item) {
      setInitialValues(cloneDeep(item));
      setReady(true);
    }
  }, [item, setInitialValues]);
  if (!ready) {
    return null;
  }
  return <CustomFieldForm2 editMode={item != null} onClose={onClose} />;
}
